export const SITE_URL = "https://stayhealthy.aminajaved.com";
export const SITE_NAME = "StayHealthy";
export const PORTFOLIO_URL = "https://aminajaved.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

export const DEFAULT_SEO = {
  title: "StayHealthy | Doctor Appointment Booking",
  description:
    "StayHealthy medical appointment booking platform. Book doctor appointments online, access remote consultations, and manage your healthcare profile.",
  keywords:
    "doctor appointment, remote doctor access, online consultation, medical booking, healthcare, StayHealthy, book doctor, telemedicine, patient portal",
};

export const ROUTE_SEO = {
  "/": {
    title: "StayHealthy | Doctor Appointment Booking",
    description:
      "Book doctors, get instant consultations, and manage your care on StayHealthy — a secure medical appointment platform.",
  },
  "/home": {
    title: "Dashboard | StayHealthy",
    description: "Access appointment booking, instant consultation, health blog, and patient services on StayHealthy.",
  },
  "/login": {
    title: "Login | StayHealthy",
    description: "Sign in to your StayHealthy patient account to book appointments and manage your profile.",
  },
  "/signup": {
    title: "Sign Up | StayHealthy",
    description: "Create a free StayHealthy account to book doctor appointments and manage your healthcare online.",
  },
  "/bookingconsultation": {
    title: "Book Appointment | StayHealthy",
    description: "Search doctors by specialty and book scheduled consultations with date and time selection.",
  },
  "/instantconsultation": {
    title: "Instant Consultation | StayHealthy",
    description: "Connect with a doctor immediately for urgent medical advice through StayHealthy.",
  },
  "/healthblog": {
    title: "Health Blog | StayHealthy",
    description: "Read practical health and nutrition tips from the StayHealthy wellness blog.",
  },
  "/selfcheckup": {
    title: "Self Checkup | StayHealthy",
    description: "Learn essential at-home health checks to monitor your wellbeing between doctor visits.",
  },
  "/reviewform": {
    title: "Patient Reviews | StayHealthy",
    description: "Share consultation feedback and star ratings for doctors on StayHealthy.",
  },
  "/profilecard": {
    title: "Patient Profile | StayHealthy",
    description: "View and update your personal health information on your StayHealthy profile.",
  },
  "/reportslayout": {
    title: "Medical Reports | StayHealthy",
    description: "Access and download your medical reports from StayHealthy consultations.",
  },
};
